import React from 'react'
import styled from 'styled-components'
import {Link, useNavigate} from 'react-router-dom'
import {ArrowBack} from '@mui/icons-material'
import Logo from './Logo'

const Container = styled.section`
    position: fixed;
    background: #3c3d4c;
    top: 0;
    left: 0;
    width: ${props => props.size ? props.size : global.SIDE_BAR_NORMAL_WIDTH}px;
    height: 100vh;
    color: white;
    z-index: 1111;
`

const LogoLink = styled(Link)`
    margin: ${props => props.size ? '10px' : '10px 20px'};
    width: ${props => props.size ? '60px' : '216px'};
    height: ${props => props.size ? '50px' : '67px'};
    display: block;

    img {
        max-width: ${props => props.size ? '60px' : '216px'};
        max-height: ${props => props.size ? '50px' : '67px'};
    }

    span {
        ${props => props.size && `
            width: 33px;
            display: block;
            height: 33px;
            margin: auto;
            overflow: hidden;
        `}
    }
`

const Back = styled.div`
    margin: 10px;
    display: flex;
    justify-content: center;
    cursor: pointer;

    :hover {
        > svg {
            color: #ffc300;
        }
    }
`

const Sidebar = ({size, logo, children}) => {
	let navigate = useNavigate()
	return (
		<Container size={size}>
			<LogoLink size={size} to={'/'}>
			{!logo ?
				<span><Logo /></span> :
				<img src={logo} alt='' />
			}
			</LogoLink>
			{size &&
				<Back onClick={() => navigate(-1)}>
					<ArrowBack />
				</Back>
			}
			{children}
		</Container>
	)
}

export default Sidebar
